<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">View Status Option</h4>
                </md-card-header>
                <md-card-content>
                    <div class="text-right">
                        <md-button @click="goBack" class="md-primary md-dense">
                            Back to List
                        </md-button>
                    </div>
{{statusOption.name}}
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>

export default {

    data: () => ({
        statusOption: {
            name: null,
            model: null,
            color: null,
            order: null,
            type: 'statusOptions',
        },
    }),

    created () {
        this.get();
    },

    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('statusOptions/get', id);
                this.role = this.$store.getters['statusOptions/statusOption'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('statusOptions/update', this.statusOption);
                await this.$store.dispatch(
                    'alerts/success',
                    'department updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        goBack () {
            this.$router.push({ name: 'Status Options List' });
        },
    },
};

</script>
